/**
 * Table speeds: every shared table has 10 seats and 1,000 chips each; the
 * first ante and how it rises set how long a game lasts (the server's
 * TABLE_SPEEDS — game lengths simulated with the bots, about 3 minutes a hand).
 */

export type TableSpeed = 'relaxed' | 'standard' | 'turbo';

export const TABLE_SPEEDS: Array<{ key: TableSpeed; name: string; rise: string; length: string }> = [
  { key: 'relaxed', name: 'Relaxed', rise: 'Ante +10% a hand', length: 'about an hour' },
  { key: 'standard', name: 'Standard', rise: 'Ante 50, +25 every 3 hands', length: 'about an hour and a half' },
  { key: 'turbo', name: 'Turbo', rise: 'Ante doubles every 2 hands', length: 'about 35 minutes' },
];

/** How a table's ante rises, in words ("+50 a hand", "+25 every 3 hands"), from the server's anteGrowth / anteIncrease / anteEvery. */
export function anteRise(table: { anteGrowth?: string; anteIncrease?: number; anteEvery?: number }): string | null {
  const step = table.anteIncrease ?? 0;
  if (!step) return null;
  if (table.anteGrowth === 'percent') return `+${step}% a hand`;
  if (table.anteGrowth === 'double') return step === 1 ? 'doubles every hand' : `doubles every ${step} hands`;
  const every = table.anteEvery ?? 1;
  return every > 1 ? `+${step} every ${every} hands` : `+${step} a hand`;
}
